import React from 'react';
import { StickyWrapper } from '..';
import { doLogin } from '../../hooks';
import { configService } from '../../services';
import i18n from "../../i18n"
import { Helmet } from 'react-helmet';
import 'bootstrap/dist/css/bootstrap.min.css';


export const LoginTile: React.FC = () => {

  let appId = process.env.REACT_APP_CLIENTID;
  const t = i18n.t;

  if (appId === "zebratechnologies") {
    return <>
      <Helmet>
        <title>{configService.current().applicationTitle} - {t("page_title_login")}</title>
      </Helmet>
      <div className='login-page'>
        <div className='d-flex flex-column justify-content-between align-items-center vw-100 vh-100'>
          <div>
            <strong>{appId}</strong> - {i18n.language}<br />
            {t("app_name")}
          </div>

          <div className='d-flex flex-column justify-content-between align-items-center gap-4'>
            <img src="https://www.zebra.com/content/experience-fragments/zebra1/gb/en/header/master/_jcr_content/root/image.coreimg.svg/1757099948396/zebra-logo-horizontal.svg" loading="lazy" className="cmp-image__image" alt="Zebra Technologies" />
            <button className='btn btn-primary m-x-05 text-decoration-none' onClick={() => doLogin()}>{t("user_login")}</button>
          </div>

          <div className='d-flex justify-content-between align-items-center w-100'>
            <a className='p-3' href="https://www.zebra.com/us/en/privacy-policy.html" target="_blank" rel="noopener noreferrer">{t("footer_privacy")}</a>
            <a className='p-3' href="https://www.zebra.com/us/en/privacy-policy.html" target="_blank" rel="noopener noreferrer">{t("footer_cookies")}</a>
          </div>

        </div>
      </div>
    </>
  }

  return (
    <StickyWrapper>
      <div className='card p-top-1 p-bottom-2'>
        <div className='d-flex flex-column align-items-center'>
          <div className='text-center'>
            <h3>Join {configService.current().applicationTitle}</h3>
            <p>Score points, earn rewards and compete against other team members for big prizes. Do you have what it takes?</p>
            <div className='d-flex align-items-center justify-content-center flex-wrap'>
              <button className='btn btn-primary m-x-05 text-decoration-none' onClick={() => doLogin()}>LOGIN</button>
              <button className='btn btn-primary btn-hollow m-x-05 text-decoration-none' onClick={() => doLogin()}>REGISTER</button>
            </div>
          </div>
        </div>
      </div>
    </StickyWrapper>
  )
}